import angular from 'angular';
import batchErrorsComponent from './batchErrors.component';

let batchErrorsModule = angular.module('batchErrors', []).component('batchErrors', batchErrorsComponent);

export
default batchErrorsModule;


// WEBPACK FOOTER //
// ./app/components/batchErrors/batchErrors.js